export default "__VITE_ASSET__947da80f__"